import type { components } from '@/types/apiSchema';

type Capacity = components['schemas']['MessageRateLimitCapacityResponse'];

/** A sending cap Finlay has used up for the account. */
export interface PausedLimit {
  kind: 'invitations' | 'messages';
  period: 'today' | 'this week';
  max: number;
}

/**
 * The cap holding sends back, if any. These are Finlay's own caps, counted
 * over the last 24 hours and 7 days; the send worker keeps what they hold
 * back queued and retries hourly, so it goes out on its own. Weekly caps
 * are named before daily ones, since they free up last.
 */
export function pausedLimit(capacity: Capacity): PausedLimit | undefined {
  const limits: [boolean, PausedLimit][] = [
    [
      capacity.remainingInvitationsThisWeek <= 0,
      {
        kind: 'invitations',
        period: 'this week',
        max: capacity.maxInvitationsPerWeek,
      },
    ],
    [
      capacity.remainingMessagesThisWeek <= 0,
      {
        kind: 'messages',
        period: 'this week',
        max: capacity.maxMessagesPerWeek,
      },
    ],
    [
      capacity.remainingInvitationsToday <= 0,
      {
        kind: 'invitations',
        period: 'today',
        max: capacity.maxInvitationsPerDay,
      },
    ],
    [
      capacity.remainingMessagesToday <= 0,
      { kind: 'messages', period: 'today', max: capacity.maxMessagesPerDay },
    ],
  ];
  return limits.find(([isUsedUp]) => isUsedUp)?.[1];
}
